(()=>{
function boot(){document.querySelectorAll('[data-shipping-crush]').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
const config=JSON.parse(root.querySelector('[data-sc-config]').textContent),buttons=[...root.querySelectorAll('[data-buy]')];
const status=root.querySelector('[data-checkout-status]');let clearStatus=0,busy=false;
function report(message){clearTimeout(clearStatus);status.textContent=message;status.hidden=false;clearStatus=setTimeout(()=>status.hidden=true,10000);}
buttons.forEach(button=>button.addEventListener('click',async()=>{
 tick?.();if(busy)return;if(root.dataset.available!=='true'){report(config.soldout);return;}
 busy=true;let native=root.querySelector('.sc-native-form ._rsi-buy-now-button');
 if(!native){report(config.loading);for(let i=0;i<30&&!native;i++){await new Promise(resolve=>setTimeout(resolve,250));native=root.querySelector('.sc-native-form ._rsi-buy-now-button');}}
 busy=false;tick?.();if(native){status.hidden=true;native.click();}else report(config.error);
}));
const sticky=root.querySelector('.sticky-buy'),primary=[...root.querySelectorAll('main [data-buy]')],visibility=new Map();let firstPassed=false;
const observer=new IntersectionObserver(entries=>{for(const e of entries){visibility.set(e.target,e.isIntersecting);if(e.target===primary[0])firstPassed=e.boundingClientRect.top<0;}sticky.classList.toggle('visible',![...visibility.values()].some(Boolean)&&(matchMedia('(max-width:799px)').matches||firstPassed));},{threshold:0});primary.forEach(b=>observer.observe(b));
const getOfferState=function offerState(offer, now = Date.now()) {
  if (offer.mode === "none")
    return { visible: false, remaining: 0, message: "" };
  let end = Date.parse(offer.endAt),
    renewals = 0;
  if (!Number.isFinite(end))
    return { visible: false, remaining: 0, message: "" };
  const period = offer.days * 86400000;
  if (offer.mode === "renewable" && now >= end) {
    renewals = Math.floor((now - end) / period) + 1;
    end += renewals * period;
  }
  return {
    visible: true,
    end,
    remaining: Math.max(0, Math.ceil((end - now) / 1000)),
    renewals,
    message:
      offer.mode === "renewable"
        ? (
            offer.renewalText?.trim() ||
            "Este contador se reinicia cada {dias} días."
          ).replaceAll("{dias}", String(offer.days))
        : now >= end
          ? "La vigencia anunciada terminó. Consulta la disponibilidad actual."
          : "",
  };
};const deadline=root.querySelector('[data-deadline]');let timer,tick;const offer=JSON.parse(root.querySelector('[data-studio-offer]').textContent);if(deadline){tick=()=>{const current=getOfferState(offer);if(!current.visible){deadline.hidden=true;return;}const s=current.remaining,parts={days:Math.floor(s/86400),hours:Math.floor(s%86400/3600),minutes:Math.floor(s%3600/60),seconds:s%60};Object.entries(parts).forEach(([key,value])=>deadline.querySelector('[data-unit="'+key+'"]').textContent=String(value).padStart(2,'0'));const label=deadline.querySelector('[data-deadline-label]');label.hidden=!current.message;label.textContent=current.message;deadline.hidden=false;};tick();timer=setInterval(tick,1000);}
root.querySelectorAll('[data-shipping-terms]').forEach(link=>link.addEventListener('click',()=>root.querySelector('#envio-gratis')?.setAttribute('open','')));
const refreshTimer=()=>{if(!document.hidden)tick?.();};
document.addEventListener('visibilitychange',refreshTimer);
document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){observer.disconnect();clearInterval(timer);clearTimeout(clearStatus);document.removeEventListener('visibilitychange',refreshTimer);}},{once:true});
});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();document.addEventListener('shopify:section:load',boot);
})();

/* AMELIE_VIDEO_AUTOPLAY_START */
// eslint-disable-next-line no-extra-semi -- Safely append to an existing theme asset.
;(() => {
  if (window.__amelieVideoAutoplayV1) {
    window.__amelieVideoAutoplayV1.scan();
    return;
  }
  const players = new Map();
  const observer = typeof IntersectionObserver === 'function'
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const player = players.get(entry.target);
          if (!player) return;
          if (!entry.isIntersecting || entry.intersectionRatio < 0.1) {
            player.visible = false;
            player.manualPause = false;
            player.blocked = false;
            player.completed = false;
          } else if (entry.intersectionRatio >= 0.35) {
            player.visible = true;
          }
          sync(player);
        });
      }, { threshold: [0, 0.1, 0.35] })
    : null;

  function allowed(player) {
    return player.video.isConnected && player.visible && !document.hidden;
  }
  function pause(player) {
    if (!player.video.paused) {
      player.automaticPauses++;
      player.video.pause();
    }
  }
  function sync(player) {
    if (!allowed(player)) {
      pause(player);
      return;
    }
    if (player.pending || player.manualPause || player.blocked || player.completed || !player.video.paused) return;
    player.pending = true;
    try {
      Promise.resolve(player.video.play()).then(() => {
        player.pending = false;
        if (!allowed(player)) pause(player);
      }, error => {
        player.pending = false;
        // Keep the clean poster visible if the browser declines autoplay.
        if (allowed(player) && error?.name !== 'AbortError') player.blocked = true;
      });
    } catch {
      player.pending = false;
      player.blocked = true;
    }
  }
  function scan() {
    document.querySelectorAll('[data-shipping-crush] video.sc-real-video').forEach(video => {
      if (players.has(video)) return;
      // Configure once: never replace the source, call load(), or reset currentTime.
      video.defaultMuted = true;
      video.muted = true;
      video.playsInline = true;
      video.controls = false;
      video.removeAttribute('controls');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('disablepictureinpicture', '');
      const player = { video, visible: false, manualPause: false, blocked: false,
        completed: false, pending: false, automaticPauses: 0 };
      const onPause = () => {
        if (player.automaticPauses) player.automaticPauses--;
        else if (allowed(player) && !video.ended) player.manualPause = true;
      };
      const onPlay = () => {
        player.manualPause = false;
        player.blocked = false;
        player.completed = false;
        if (observer && !allowed(player)) pause(player);
      };
      const onEnded = () => { player.completed = true; };
      player.dispose = () => {
        player.visible = false;
        pause(player);
        observer?.unobserve(video);
        video.removeEventListener('pause', onPause);
        video.removeEventListener('play', onPlay);
        video.removeEventListener('ended', onEnded);
        players.delete(video);
      };
      video.addEventListener('pause', onPause);
      video.addEventListener('play', onPlay);
      video.addEventListener('ended', onEnded);
      players.set(video, player);
      observer?.observe(video);
    });
  }
  window.__amelieVideoAutoplayV1 = { scan };
  document.addEventListener('visibilitychange', () => players.forEach(sync));
  window.addEventListener('pagehide', () => players.forEach(pause));
  window.addEventListener('pageshow', () => players.forEach(sync));
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    players.forEach(player => {
      if (event.target.contains(player.video)) player.dispose();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
/* AMELIE_VIDEO_AUTOPLAY_END */
